import api from 'Application/api/api';

const logout = () => api.get('/auth/logout');

export default logout;
